var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"py-3 bg-white",attrs:{"fluid":true}},[_c('b-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }